import getTrainingAuthSelector from 'modules/training/modules/app-auth/selectors/get'
import { TRAINING_AUTH_KEY } from 'modules/training/modules/app-auth/constants'

const getEmailOrNameTrainingAuthSelect = (
  getTrainingAuthSelector(TRAINING_AUTH_KEY.EMAIL_OR_NAME)
)

export default getEmailOrNameTrainingAuthSelect
